let questionsButtons = document.getElementsByClassName("questions-btn")
if(questionsButtons)
{
    for (let i = 0; i < questionsButtons.length; i++) {
        questionsButtons[i].addEventListener('click', (event) => {
            console.log(i)
            let target = event.currentTarget
            let icon = target.querySelector(".questions-btn__icon")
            let answer = document.querySelectorAll(".questions-answers-list .answer-text")[i]

            icon.classList.toggle("active")
            answer.classList.toggle("expanded")

        }, i)
    }
}
